import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token   = localStorage.getItem('token');
    const role    = localStorage.getItem('role');
    const roles   = JSON.parse(localStorage.getItem('roles') || '[]');
    const adminId = localStorage.getItem('admin_id');
    const name    = localStorage.getItem('admin_name');
    if (token && role) setUser({ token, role, roles, adminId, name });
    setLoading(false);
  }, []);

  const login = ({ token, role, roles, adminId, name }) => {
    const rolesArr = Array.isArray(roles) ? roles : (role ? [role] : []);
    localStorage.setItem('token',      token);
    localStorage.setItem('role',       role);
    localStorage.setItem('roles',      JSON.stringify(rolesArr));
    localStorage.setItem('admin_id',   adminId ?? '');
    localStorage.setItem('admin_name', name ?? '');
    setUser({ token, role, roles: rolesArr, adminId, name });
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  // Check if current user has a specific permission (requires roles API data to be fetched by caller)
  const hasPermission = (permission, rolePermissions = {}) => {
    if (!user) return false;
    if (user.role === 'superadmin') return true;
    return (rolePermissions[user.role] || []).includes(permission);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
